<template>
  <div class="component-container">
    <div class="member-register-head">
      <div style="height: 46px;margin-top: 20px;">
        <span style="text-align: center;font-weight: bold;font-size: 32px;margin-top: 25px;">欢迎注册红砖智库系统</span>
      </div>
      <div class="arrowsBoxDiv">
        <div class="arrowsBox">
          <div class="arrowsItem" v-for="(item, index) in list" :key="index">
            <div v-if="index == 0" style="height: 100%;margin-right: -90px;padding-left: 40px" >
              <div style="width: 10%;border-top-left-radius: 10px;border-bottom-left-radius: 10px;height: 100%;float: left"
                   :class="{
                arrows_active: item.status === 'active',
                arrows_done: item.status === 'done',
                arrows_todo: item.status === 'todo',
              }">
              </div>
              <div class="step-label" style=""
                   :class="{
                arrows_active: item.status === 'active',
                arrows_done: item.status === 'done',
                arrows_todo: item.status === 'todo',
              }">
                <i :class="item.icon+' iconfont'
            +(item.status === 'active'?' icon_active':'')
            +(item.status === 'done'?' icon_done':'')
            +(item.status === 'todo'?' icon_todo':'')"></i>
                <span style="" :class="{
                arrows_label_active: item.status === 'active',
                arrows_label_done: item.status === 'done',
                arrows_label_todo: item.status === 'todo',
              }">{{item.label}}</span>
              </div>
              <div class="right-jiantou" :style="'border-left: 20px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':'')">
              </div>
            </div>

            <div v-if="index == 1" style="height: 100%;margin-right: -100px;padding-left: 10px">
              <div class="left-shousuo" :style="('border-top: 30px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':''))+(';border-bottom: 30px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':''))"
                   >
              </div>
              <div class="step-label" style="" :class="{
                arrows_active: item.status === 'active',
                arrows_done: item.status === 'done',
                arrows_todo: item.status === 'todo',
              }">
                <i :class="item.icon+' iconfont'
            +(item.status === 'active'?' icon_active':'')
            +(item.status === 'done'?' icon_done':'')
            +(item.status === 'todo'?' icon_todo':'')"></i>
                <span style="" :class="{
                arrows_label_active: item.status === 'active',
                arrows_label_done: item.status === 'done',
                arrows_label_todo: item.status === 'todo',
              }">{{item.label}}</span>
              </div>
              <div class="right-jiantou" :style="'border-left: 20px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':'')">
              </div>
            </div>
            <div v-if="index == 2" style="height: 100%;margin-right: -50px;margin-left: -10px;">
              <div class="left-shousuo" :style="('border-top: 30px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':''))+(';border-bottom: 30px solid '
              +(item.status === 'active'?'#31c3e7':'')
            +(item.status === 'done'?'#e0f7fc':'')
            +(item.status === 'todo'?'#ebedf0':''))"
              >
              </div>
              <div class="step-label" style="":class="{
                arrows_active: item.status === 'active',
                arrows_done: item.status === 'done',
                arrows_todo: item.status === 'todo',
              }">
                <i :class="item.icon+' iconfont'
            +(item.status === 'active'?' icon_active':'')
            +(item.status === 'done'?' icon_done':'')
            +(item.status === 'todo'?' icon_todo':'')"></i>
                <span style="" :class="{
                arrows_label_active: item.status === 'active',
                arrows_label_done: item.status === 'done',
                arrows_label_todo: item.status === 'todo',
              }">{{item.label}}</span>
              </div>
              <div style="width: 10%;border-top-right-radius: 10px;border-bottom-right-radius: 10px;height: 100%;float: left"
                   :class="{
                arrows_active: item.status === 'active',
                arrows_done: item.status === 'done',
                arrows_todo: item.status === 'todo',
              }">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="member-register-body">
        <div style="padding-top: 5px">
          <template v-if="active==0">
            <div style="text-align: center;">
            <span style="box-sizing: border-box;">红砖智库系统用户使用协议书</span>
            <el-form >
              <el-form-item style="line-height: 15px; padding-top:10px;" prop="info">
<!--                <yl-scrollbar customHeight = '100vh - 600px'>-->
                <div style="overflow-y: auto;height: calc(100vh - 600px);min-height: 200px">
                    <p class="info">
                      在此特别提醒您在注册成为用户之前，请认真阅读本《服务协议》（以下简称“协议”），确保您充分理解本协议中的各项条款。请您谨慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款a否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议约定我方与用户之间关于App软件服务（以下简称“服务”）的权利义务。用户，是指注册、登录、使用本服务的个人或组织。本协议可由我方随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本App中查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用我方提供的服务，用户继续使用我方提供的服务将被视为接受修改后的协议。
                    </p>
                    <p class="info">
                      一、账号注册

                      1、用户在使用本服务前需要注册一个App账号。本App账号应当使用手机号码、邮箱绑定注册，请用户使用尚未与本App账号绑定的手机号码，以及未被我方协议封禁的手机号码注册本App账号。我方可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。

                      2、鉴于本App账号的绑定注册方式，您同意在注册本App时将允许您的手机号码及手机设备识别码等信息用于注册。

                      3、在用户注册及使用本服务时，我方需要搜集能识别用户身份的个人信息以便我方可以在必要时联系用户，或为用户提供更好的使用体验。我方搜集的信息包括但不限于用户的姓名、地址；我方同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
                    </p>
                    <p class="info">
                      二、用户个人隐私信息保护

                      1、如果我方发现或收到他人举报或投诉用户违反本协议约定的，我方有权不经通知随时对相关内容，包括但不限于用户资料、发布记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁、设备封禁、功能封禁的处罚，且通知用户处理结果。

                      2、因违反用户协议被封禁的用户，可以自行与我方联系。其中，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可提交申诉，我方将对申诉进行审查，并自行合理判断决定是否变更处罚措施。

                      3、用户理解并同意，我方有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。

                      4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿我方与合作公司、关联公司，并使之免受损害。
                    </p>
                    <p class="info">
                      三、用户发布内容规范

                      1、本条所述内容是指用户使用本App的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本服务所产生的内容。

                      2、用户不得利用本App账号或本服务制作、上传、复制、发布、传播如下法律、法规和政策禁止的内容：

                      (1) 反对宪法所确定的基本原则的；

                      (2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；

                      (3) 损害国家荣誉和利益的；

                      (4) 煽动民族仇恨、民族歧视，破坏民族团结的；

                      (5) 破坏国家宗教政策，宣扬邪教和封建迷信的；

                      (6) 散布谣言，扰乱社会秩序，破坏社会稳定的；

                      (7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；

                      (8) 侮辱或者诽谤他人，侵害他人合法权益的；

                      (9) 含有法律、行政法规禁止的其他内容的信息。

                      3、用户不得利用本App账号或本服务制作、上载、复制、发布、传播如下干扰本App正常运营，以及侵犯其他用户或第三方合法权益的内容：

                      (1) 含有任何性或性暗示的；

                      (2) 含有辱骂、恐吓、威胁内容的；

                      (3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；

                      (4) 涉及他人隐私、个人信息或资料的；

                      (5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；

                      (6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
                    </p>
                    <p class="info">
                      四、使用规则

                      1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表我方的观点、立场或政策，我方对此不承担任何责任。

                      2、用户不得利用本App账号或本服务进行如下行为：

                      (1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；

                      (2) 强制、诱导其他用户关注、点击链接页面或分享信息的；

                      (3) 虚构事实、隐瞒真相以误导、欺骗他人的；

                      (4) 利用技术手段批量建立虚假账号的；

                      (5) 利用本App账号或本服务从事任何违法犯罪活动的；

                      (6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；

                      (7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰本App正常运营或我方未明示授权的行为。

                      3、用户须对利用本App账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与我方无关。如因此给我方或第三方造成损害的，用户应当依法予以赔偿。

                      4、我方提供的服务中可能包括广告，用户同意在使用过程中显示我方和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，我方不承担任何责任。
                    </p>
                    <p class="info">
                      五、其他

                      1、我方郑重提醒用户注意本协议中免除我方责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。

                      2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和我方之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交我方住所地有管辖权的人民法院管辖。

                      3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。

                      4、本协议最终解释权归我方所有，据苹果公司免责条款特此声明：该App注册及用户协议与苹果公司无关。
                    </p>
<!--                </yl-scrollbar>-->
                </div>
                <!--                          <span style="text-align: left;float: left;line-height: 15px"><b>手机号</b></span>-->
                <!--                          <el-input type="textarea" v-model="phone" placeholder="请输入手机号" style="width: 100%;height: 200px" ></el-input>-->
              </el-form-item>
              <!--         因缺失prop导致校验失效，加入占位实质无任何意义               -->
              <el-form-item label="" prop="chooseBox">
                  <el-checkbox label="我已阅读并同意《用户协议》" v-model="chooseBox" :disabled="messageDisabled"></el-checkbox>
              </el-form-item>
              <!--                        <input type="checkbox" value="同意"  v-model="message" :disabled="messageDisabled"/><span>我已阅读并同意《用户协议》</span>-->
            </el-form>
          </div>
          </template>
          <template v-if="active==1">
            <div class="register-phone-form table-form1">
<!--              <yl-scrollbar customHeight = '100vh - 620px'>-->
                <el-form  label-width="110px" class="password" :model="form1" ref="registerForm1" :rules="rules1">
                  <el-form-item style="padding-right: 10px;" label="手机号" key="phone" prop="phone">
                    <!--                          <span style="text-align: left;float: left;line-height: 15px"><b>手机号</b></span>-->
                    <el-input type="text" v-model="form1.phone" placeholder="请输入手机号" style="width: 100%;" clearable @blur="checkPhone"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 10px;" class="password" key="password" label="密码" prop="password">
                    <!--                          <span style="text-align: left;float: left;line-height: 15px"><b>密码</b></span>-->
                    <el-input id="password" show-password  type="password" v-model="form1.password" placeholder="长度为10-20位，包含数字、大小写字母和符号" @blur="checkPassword"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 10px;line-height: 15px" class="password" label="确认密码" key="confirmPassword" prop="confirmPassword">
                    <!--                          <span style="text-align: left;float: left;line-height: 15px"><b>确认密码</b></span>-->
                    <el-input show-password  type="password" v-model="form1.confirmPassword" placeholder="请输入确认密码" @blur="checkConfirmPassword"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 10px;line-height: 15px" label="邀请码" key="inviteCode" prop="inviteCode" @blur="checkInviteCode">
                    <el-input type="text" v-model="form1.inviteCode" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 100px;line-height: 15px" class="password" label="短信验证码" prop="phoneRegisteCode" key="phoneRegisteCode">
                    <!--                          <span style="text-align: left;float: left;line-height: 15px"><b>短信验证码</b></span>-->
                    <el-input type="text" v-model="form1.phoneRegisteCode"  placeholder="请输入短信验证码" ></el-input>
                    <el-button type="info" size="small" :class="sms.disable?'not-click-send':'click-send'" style="position: absolute; width: 90px;border: 0px solid rgb(204, 204, 204) ;color: white;height: 40px;margin-top: 1px"
                               @click="getSmsCodeForRegiste" :disabled="sms.disabled">{{ sms.massage }}</el-button>
                  </el-form-item>
                </el-form>
<!--              </yl-scrollbar>-->
            </div>
          </template>
          <template v-if="active==2">
            <div class="register-phone-form table-form2">
<!--              <yl-scrollbar customHeight = '100vh - 520px'>-->
                <el-form  label-width="150px" :model="form2" :rules="rules2" ref="registerForm2">
                  <el-form-item style="padding-right: 30px;" label="姓名" key="userName" prop="userName">
                    <el-input type="text" v-model="form2.userName" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 30px;" label="性别" prop="gender" key="gender">
                    <el-select v-model="form2.gender" placeholder="请选择" clearable style="width: 100%">
<!--                      <el-option label="无" value=""></el-option>-->
                      <el-option label="男" value="1"></el-option>
                      <el-option label="女" value="0"></el-option>
                    </el-select>
                  </el-form-item>

                  <!--                <el-form-item label="省份市级:" prop="provinceCode" style="font-weight:500">-->
                  <!--                  <el-cascader-->
                  <!--                    ref="codeCascader"-->
                  <!--                    :props="{ checkStrictly: true }"-->
                  <!--                    :options="codesTree"-->
                  <!--                    v-model="form2.pCodeAndCCode"-->
                  <!--                    popper-class="disableFirstLevel"-->
                  <!--                    separator=""-->
                  <!--                    @change="handleCodeChange"-->
                  <!--                    clearable filterable-->
                  <!--                    style="width: 100%">-->
                  <!--                  </el-cascader>-->
                  <!--                </el-form-item>-->

                  <el-form-item style="padding-right: 30px;" label="科室" prop="section" key="section">
                    <el-input type="text" v-model="form2.section" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 30px;" label="一级研究方向" key="lv1Code" prop="lv1Code">
                    <el-select v-model="form2.lv1Code" placeholder="请选择" style="width: 100%" clearable @change="chooseLv1Value">
                      <el-option
                        v-for="item in lv1TpCodes"
                        :key="item.cd"
                        :label="item.cdDesc"
                        :value="item.cd">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="padding-right: 30px;" label="二级研究方向" prop="lv2Code" key="lv2Code" required v-if="form2.lv1Code">
                    <el-select v-model="form2.lv2Code" placeholder="请选择" style="width: 100%" clearable>
                      <el-option
                        v-for="item in lv2TpCodes.filter((a) => a.parentCd===form2.lv1Code)"
                        :key="item.cd"
                        :label="item.cdDesc"
                        :value="item.cd">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="padding-right: 30px;" label="二级研究方向(其他)" key="lv2Desc" prop="lv2Desc" required v-if="form2.lv2Code==='013-9999' || form2.lv2Code.length > 7">
                    <el-input type="text" v-model="form2.lv2Desc" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item style="padding-right: 30px;line-height: 15px" label="所属机构" key="departmentName" prop="departmentName">
                    <!--                  <el-input type="text" v-model="form2.departmentName" placeholder="请选择"/>-->
                    <el-autocomplete
                      v-model="form2.departmentName"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="请输入内容（若不存在可填入新机构名称）"
                      @select="handleSelect"
                      style="width: 100%"
                    ></el-autocomplete>
                    <el-popover
                      placement="top-start"
                      title=""
                      width="200"
                      trigger="hover"
                      content="若无存在所属机构，则填入新机构名称。">
                      <button slot="reference" type="button" title="" style="position: absolute;top: 8px;" class="eims-button eims-button--text el-icon-question"></button>
                    </el-popover>
                  </el-form-item>
                </el-form>
<!--              </yl-scrollbar>-->
            </div>
          </template>
          <div>
            <div class="register-card-foot">
                <button class="back-up" @click="back" style="" v-if="active!=0">上一步</button>
                <button :class="'register-button '+((messageDisabled || !chooseBox)?'is-disabled':'')"
                        style="color: white"
                        :disabled="messageDisabled || !chooseBox" @click="next">
                    <span v-if="active!=2">下一步</span>
                    <span v-if="active==2">确认注册</span>
                </button>
            </div>
            <div style="padding-bottom: 5px;">
              <span style="height: 40px;font-size: 14px;">已有账号，</span>
              <el-button type="text" @click="goToLogin">去登录</el-button>
            </div>
          </div>
        </div>
    </div>
    <Animation :loadingDataVisible="loadingDataVisible" :loadingText="'处理中'"/>
  </div>
</template>

<script>
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import {mapState} from "vuex";
  import {Message} from "element-ui";
  import * as constantsRules from '@/constants/constantRules'
  import Animation from "./loading/animation";
    export default {
        name: "Register",
      components: {Animation},
      data(){
          return {
            active:0,
            chooseBox:false,
            info:'',
            messageDisabled:false,
            message:'',
            departments: [], //部门数组
            sms: {
              massage:"获取验证码",
              disable:false,
              count: 60,
              isSendFlag:false,
            },
            list: [
              {
                label: "用户使用协议书",
                prop: "1",
                status: "active",
                icon: 'icon-shuji',
              },{
                label: "手机号注册",
                prop: "2",
                status: "todo",
                icon: 'icon-shouji',
              },{
                label: "基本信息填写",
                prop: "3",
                status: "todo",
                icon: 'icon-gerenziliao',
              },
            ],
            form2:{
              provinceCode:'',
              cityCode:'',
              userName: '',
              departmentName: '',
              ethnicityCode:'',
              gender:'',
              birthDate:'',
              idNumber:'',
              pCodeAndCCode:[],
              lv1Code:'',
              lv2Code:'',
              lv2Desc:'',
              section:'',

            },
            loadingDataVisible:false,
            form1:{
              phone:'',
              phoneRegisteCode: '',
              password: '',
              confirmPassword: '',
              inviteCode:'',
            },
            inviteCode: '',
            inviteUserName: '',
            inviteOrgName: '',
            departmentId: '',
            query: '',
            lv1TpCodes:[],
            lv2TpCodes:[],
            infoHeight: {
              height: ''
            },
            timeout:null,
            rules1: constantsRules.registerRules1,
            rules2: constantsRules.registerRules2,
          }
      },
      created(){
        window.addEventListener('resize', this.getHeight);
        this.getHeight();
        this.getBaseCodes();
      },
      mounted() {
        this.getInviteCode();
      },
      methods:{
        //设置自适应高度
        getHeight() {

        },
        //查询部门id
        getDepartments(){
          //let token = cookie.getCookie("token");
          //http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', {
          //  token: token,
          //  data: {
          //    pageSize: -1
          //  }
          //}).then(response => {
          //  this.departments = response.data.data.departments;
          //})
        },
        //获取基本信息页面码值
        getBaseCodes() {
          let _this = this;
          _this.loadingData = true;
          let token = cookie.getCookie("token");
          http.post(window.config.api.baseUrl + '/eims-api/code/getCodes/registerCode', {
            token: token,
            data: {}
          }).then(value => {
            if (value.data.code === '00000') {
              this.codes = value.data.data;
              let lv1Code = this.codes['012'];
              let lv2Code = this.codes['013'];
              this.lv1TpCodes = lv1Code;
              this.lv2TpCodes = lv2Code;
            }
          }).finally(() => {
            _this.loadingData = false;
          })
        },
        querySearchAsync(queryString, cb) {
          let _this = this
          clearTimeout(_this.timeout);
          // this.data.isLoading = true;
          http.post(window.config.api.baseUrl + '/eims-api/department/getAllDepartmentName', {
            token: cookie.getCookie("token"),
            data: {
              departmentName:queryString
            }
          }).then((response)=> {
            let data =  response.data.data;
            let tmpData = [];
            for (let i in data.departments) {
              let obj = {
                value:data.departments[i]
              }
              tmpData.push(obj)
            }
            _this.departments = tmpData
          }).finally(() => {
            _this.timeout = setTimeout(() => {
              cb(_this.departments);
            }, 1000 * Math.random());
            // _this.data.isLoading = false;
          });
        },
        handleSelect(item) {
          this.form2.departmentName = item.value;
        },
        checkPhone(){
          this.$refs['registerForm1'].validateField(['phone'],(valid) =>{
          })
        },
        checkPassword(){
          this.$refs['registerForm1'].validateField(['password'],(valid) =>{
            if (valid === ''){
              if (this.form1.confirmPassword.length>0){
                this.$refs['registerForm1'].validateField(['confirmPassword'],(valid) =>{})
              }
            }
          })
        },
        checkConfirmPassword(){
          let this_ = this;
          this.$refs['registerForm1'].validateField(['password'],(valid) =>{
            if (!valid) {
              // this_.$refs['registerForm1'].validateField(['confirmPassword'],(valid) =>{})
            }
          })
        },
        checkInviteCode(){
          let this_ = this;
          this.$refs['registerForm1'].validateField(['inviteCode'],(valid) =>{
          })
        },
        next(){
          if (this.active===2){
            this.registerPost()
          } else if (this.active == 1){
            if (!this.sms.isSendFlag && this.form1.phoneRegisteCode === ''){
              Message.error("请获取短信验证码");
              return false;
            }
              if (!this.validateDialogForm1()) {
                return false;
              }
              this.loadingDataVisible = true;
              http.post(window.config.api.baseUrl + '/eims-api/user/checkSmsCode', {
                data: {
                  userId: this.form1.phone,
                  phoneRegisteCode: this.form1.phoneRegisteCode,
                  registKey: this.registKey,
                  inviteCode: this.form1.inviteCode,
                }
              }).then(response => {
                let responseData = response.data;
                // this.active=2;
                // for (let item of this.list) {
                //   if (item.status === "active") {
                //     item.status = "done";
                //   }
                //   if (item.status === "todo") {
                //     item.status = "active";
                //     if (this.list[this.list.length - 1].status === "active") {
                //     }
                //     break;
                //   }
                // }
                if (responseData.code == '00000'){
                 this.active=2;
                 for (let item of this.list) {
                   if (item.status === "active") {
                     item.status = "done";
                   }
                   if (item.status === "todo") {
                     item.status = "active";
                     if (this.list[this.list.length - 1].status === "active") {
                     }
                     break;
                   }
                 }
                 // this.$router.push({path: '/login'});
                }else if (responseData.code == '10012') {

                }
              }).finally(() => {
                this.loadingDataVisible = false;
              })
            }else if (this.active == 0) {
              this.active++
              for (let item of this.list) {
                if (item.status === "active") {
                  item.status = "done";
                }
                if (item.status === "todo") {
                  item.status = "active";
                  if (this.list[this.list.length - 1].status === "active") {
                  }
                  break;
                }
              }
          }

        },
        back(){
          if (this.active==1){
            this.$refs['registerForm1'].resetFields();
          }
          if (this.active==2) {
            // this.$refs['registerForm1']?this.$refs['registerForm1'].resetFields():'';
            this.$refs['registerForm2'].resetFields();
          }
          if (this.active===0){
            return;
          }
          this.active--;
          for (let i = this.list.length-1; i => 0; i--) {
            let item = this.list[i];
            if (item.status === "active") {
              item.status = "todo";
            }

            if (item.status === "done") {
              item.status = "active";
              if (this.list[0].status === "active") {
              }
              break;
            }
          }
        },

        //短信验证码倒计时
        getCode() {
          this.sms.massage = "重新获取(" + this.sms.count + ")";
          this.sms.count--;
          if (this.sms.count <= 0) {
            this.sms.count = 60;
            this.sms.massage = "获取验证码";
            this.sms.disable = false;
          } else {
            this.sms.disable = true;
            setTimeout(() => {
              this.getCode();
            }, 1000);
          }
        },

        //获取注册短信验证码
        getSmsCodeForRegiste(){
          let _this = this;
          this.$refs['registerForm1'].validateField(['phone'],(valid) =>{
            if (valid === ''){
              http.post(window.config.api.baseUrl + '/eims-api/user/smsCodeForRegiste', {
                data: {
                  userId: _this.form1.phone,
                  key: _this.registKey,
                }
              }).then(response => {
                let responseData = response.data;
                if (responseData.code == '00000'){
                  Message.success({message: "短信验证码已发送", showClose: true})
                  _this.registKey = responseData.data.key;
                  _this.getCode();
                  this.sms.isSendFlag = true;

                }
              }).catch(error => {
                Message.error({message: "获取短信验证码失败", showClose: true});
              });
            }
          })
        },

        //注册
        registerPost() {

          if (!this.validateDialogForm2()) {
            return false;
          }
          // if (this.form2.lv2Code.length > 7){
          //   this.form2.lv2Code = '013-999';
          // }
          http.post(window.config.api.baseUrl + '/eims-api/user/register', {
            data: {
              userId: this.form1.phone,
              password: this.form1.password,
              confirmPassword: this.form1.confirmPassword,
              phoneRegisteCode: this.form1.phoneRegisteCode,
              name: this.form2.userName,
              departmentName: this.form2.departmentName,
              provinceCode: this.form2.provinceCode,
              cityCode: this.form2.cityCode,
              idNumber: this.form2.idNumber,
              inviteCode: this.form1.inviteCode,
              lv1Code: this.form2.lv1Code,
              lv2Code: this.form2.lv2Code,
              lv2Desc: this.form2.lv2Desc,
              gender: this.form2.gender,
              section: this.form2.section,
              registKey: this.registKey,
              department: this.departmentId,
            }
          }).then(response => {
            let responseData = response.data;
            if (responseData.code == '00000'){
              Message.success({message: "注册成功", showClose: true});
              var token = responseData.data.token;
              cookie.setCookie('token', token, null, 1800);
              //注冊成功，跳转到主界面
              this.$router.push({path: '/home'});
            }else if (responseData.code == '10012') {
              this.active=1;
            }
          })

        },

        handleCodeChange(value){
          if (value && value.length>0){
            this.$refs.codeCascader.dropDownVisible = false
            this.form2.provinceCode = value[0];
            this.form2.cityCode = value.length>1?value[1]:'';
          }
        },
        validateDialogForm1() {
          let result = false;
          this.$refs['registerForm1'].validate((valid) => {
            if (valid) {
              result = true;
            }
          });
          return result;
        },
        validateDialogForm2() {
          let result = false;
          this.$refs['registerForm2'].validate((valid) => {
            if (valid) {
              result = true;
            }
          });
          return result;
        },
        goToLogin(){
          if (this.$route.query.code) {
            this.$emit('toLogin',{"code": this.$route.query.code})
          }else {
            this.$emit('toLogin',{})
          }
        },
        //抓取页面的Code
        getInviteCode(){
          this.query = this.$route.query;
          this.form1.inviteCode = this.query.inviteCode;
          //this.getLvCode();
        },

        //获取研究方向
        getLvCode(){
          let lv1TpCodes = this.eimsCodes.filter((code) => code.tp==='012');
          let lv2TpCodes = this.eimsCodes.filter((code) => code.tp==='013');
          this.lv1TpCodes = lv1TpCodes;
          this.lv2TpCodes = lv2TpCodes;
        },

        //通过邀请码获取邀请人用户名和机构名
        getInviter(){
          if (!this.form1.inviteCode){
            return;
          }else {
            http.post(window.config.api.baseUrl + '/eims-api/user/invite/info/' + this.form1.inviteCode, {
            }).then(response => {
              let responseDate = response.data;
              if (responseDate.code == '00000'){
                if (responseDate.data){
                  this.inviteUserName = responseDate.data.userName;
                  this.inviteOrgName = responseDate.data.orgName
                  this.departmentId = responseDate.data.id;
                }
              }
            })
          }
        },
        chooseLv1Value(value){
          this.form2.lv2Code = '';
          this.form2.lv2Desc = '';
          if (value==='012-999'){
            this.form2.lv2Code = '013-9999'
          }
        }
      },
      computed: {
        ...mapState({
          codesTree: state => state.codeDictModule.codesTree,
          eimsCodes: state => state.codeDictModule.eimsCodes,
        })
      },
      watch: {
        'form2.lv2Code'(newVal,oldVal) {
          if (this.form2.lv1Code === '012-999'){
            this.form2.lv2Code = '013-9999'
          }
        },
        'eimsCodes.length'(newVal,oldVal){
          if (newVal>0){
            this.getLvCode();
          }

        }
      },
      destroyed() {
        window.removeEventListener('resize', this.getHeight);
      }
    }
</script>

<style scoped>

  *{
    transition: all 200ms linear 0s, z-index 0s linear 0s ;
  }

  *{
    opacity: 1;
  }
  .member-register-body{
    -webkit-animation-name: login-password; /*动画名称*/
    -webkit-animation-duration: 0.2s; /*动画持续时间*/
    -webkit-animation-iteration-count: 1; /*动画次数*/
    -webkit-animation-delay: 0s; /*延迟时间*/
  }
  @-webkit-keyframes login-password  {
    0% {
      opacity: 0; /*初始状态 透明度为0*/
    }
    50% {
      opacity: 0.5; /*中间状态 透明度为50*/
    }
    100% {
      opacity: 1; /*结尾状态 透明度为1*/
    }
  }
  .component-container{
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .right-jiantou{
    width:0;
    height:0;
    border-top: 30px solid #ffffff;
    border-bottom: 30px solid #ffffff;
    float: left
  }
  .left-shousuo{
    float: left;
    width:0;
    height:0;
    border-left: 20px solid #ffffff;
  }
  .step-label{
    width: 60%;
    height: 100%;
    float: left;
    padding-top: 20px
  }
  .arrowsBoxDiv{
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    margin: auto;
    padding-left: 25%;
    padding-right: 25%;
    padding: 10px 0;
  }
  .arrowsBox {
    display: flex;
    justify-content: center;
    height: 60px;
    font-weight: bold;
  }
  .arrowsItem {
    width: 30%;
    right: 20px;
  }

  .arrows {
    background: gray;
  }

  .arrows_done {
    background: #e0f7fc;
  }
  .arrows_active {
    background: #31c3e7;
  }
  .arrows_todo {
    background: #ebedf0;
  }

  .arrows_label_done {
    color: #57d5d7;
  }
  .arrows_label_active {
    color: #fff;
  }
  .arrows_label_todo {
    color: #929393;
  }
  .info{
    width: 100%;
    text-indent:2em;
    text-align: left;
    /*height: 300px;*/
    /*background-color: #BFBFBF;*/
    /*overflow-y: auto;*/
  }
  .back-up{
    outline: none;
    background-color:#ffffff;
    width: 100%;
    height: 46px;
    border-radius: 38px;
    /*box-shadow: 0px 1px 10px 0px #57d5d7;*/
    border: 1px solid #57d5d7;
    color: #57d5d7;
    font-weight: bold;
    background-blend-mode: lighten;
    background-size: cover;
  }
  .register-button{
    outline: none;
    border: none;
    /*border-radius: 38%;*/
    /*background-position:center;*/
    /*margin-left: 40px;*/
    /*text-align: center;*/
    width: 93%;
    height: 49px;
    border-radius: 43px;
    background: url(../../static/images/loginbutton.png) no-repeat;
    box-shadow: 0px 1px 10px 0px #57d5d7;
    color: white;
    font-weight: bold;
    background-blend-mode: lighten;
    background-size: cover;
  }
  .register-button.is-disabled{
    cursor: not-allowed;
  }
  .member-register-body{
    width: 80%;
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    margin: auto;
    padding: 10px;
  }
  .register-card-foot{
    width: 100%;
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    margin: 10px auto 0 auto;
    font-size: 14px;
  }
  .fade-enter-active{
    transition: all 0.2s;
  }

  fade-leave-active {
    transition: opacity 0s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .register-phone-form{
    width: 60%;
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    margin: auto;
  }
  .register-phone-form /deep/ .el-form-item__label{
    font-weight: bold;
  }
  .table-form1{
    min-height: calc(100vh - 620px);
  }
  .table-form2{
    min-height: calc(100vh - 520px);
  }
  .register-card-foot button{
    width: auto;
    min-width: 27%;
    margin-left: 30px;
  }
  i.icon_active{
    color: #f8fdfe;
  }
  i.icon_done{
    color: #57d5d7;
  }
  i.icon_todo{
    color: #cccccc;
  }
  .eims-button {
    font-size: 16px;
    margin-left: 10px;
  }
  .eims-button--text{
    border-color: transparent;
    color: red;
    background: transparent;
  }
  .click-send{
    background: #5ed5d9;
  }
  .not-click-send{
    background: rgb(204, 204, 204);
  }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue